import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

interface SendReportNotificationPayload {
  reportId: string;
  message: string;
}

export const sendReportNotification = createAsyncThunk(
  'reports/sendReportNotification',
  async (payload: SendReportNotificationPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const res = await fetch(REPORTS.SEND_REPORT_NOTIFICATION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to send notification');
      }

      return await res.json();
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to send notification');
    }
  }
);
